import { useProjects } from '../../../hooks/useProjects';

interface UseProjectsDataResult {
  projects: ReturnType<typeof useProjects>['projects'];
  sharedProjects: ReturnType<typeof useProjects>['sharedProjects'];
  loading: boolean;
  refresh: () => Promise<void>;
}

/** @deprecated Prefer `useProjects` directly — kept for ProjectsPage / ProjectPage. */
export function useProjectsData(): UseProjectsDataResult {
  const { projects, sharedProjects, loading, refresh } = useProjects();
  return { projects, sharedProjects, loading, refresh };
}
